import React, {FC, RefObject} from 'react';
import styled from 'styled-components';

import {DraftMessageModel} from '../../../../../../libs/shared/core/src/models/api/messageModel';
import {CellsContext} from '../../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {
  ApplicationsPanelId,
  ViewerPanelId,
} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {Dropdown} from '../../../../../../libs/shared/ui/src/components/dropdowns/dropdown';
import {ApplicationComposerToolbarEntryPointModel} from '../../../../../models/api/applicationEntryPointModel';
import {MessageComposerApplicationContextHostContainer} from '../../../../applications/contextHosts/messageComposerApplicationContextHostContainer';

/*
 * Constants.
 */

const panelWidth = 300; // px.
const panelHeight = 430; // px.

/*
 * Props.
 */

interface ApplicationComposerEntryPointPanelProps {
  panelId: ApplicationsPanelId;
  anchor: RefObject<HTMLDivElement>;
  frame: ApplicationComposerToolbarEntryPointModel;
  onRequestClose: () => void;
  draftMessage: DraftMessageModel;
  cellsContext: CellsContext | undefined;
  viewerPanelId: ViewerPanelId | undefined;
}

/*
 * Style.
 */

const MessageComposerContentsWrapperDiv = styled.div`
  position: relative;
  height: 100%;
`;

/*
 * Component.
 */

export const ApplicationComposerEntryPointPanel: FC<ApplicationComposerEntryPointPanelProps> = (props) => {
  const {panelId, anchor, frame, cellsContext, onRequestClose, draftMessage, viewerPanelId} = props;
  return (
    <Dropdown anchor={anchor} width={panelWidth} height={panelHeight} onRequestClose={onRequestClose}>
      <MessageComposerContentsWrapperDiv>
        <MessageComposerApplicationContextHostContainer
          applicationsPanelId={panelId}
          entryPoint={frame}
          draftMessage={draftMessage}
          cellsContext={cellsContext}
          viewerPanelId={viewerPanelId}
        />
      </MessageComposerContentsWrapperDiv>
    </Dropdown>
  );
};
